<div class="text-start mb-3" *ngFor="let ast of asterisks; let i = index">
  <span [innerHtml]="'*'.repeat(i + 1)"></span>
  <span [innerHtml]="' ' + ast"></span>
</div>
